import { Input, Select } from "antd";
import { BiPlus, BiTrash } from "react-icons/bi";
import { useTranslation } from "react-i18next";
import PayloadPathSelect from "shared/components/PayloadPaths";
import { NAME_SPACES } from "shared/locales/constants";

const EMPTY_CONDITIONS = { operator: "AND", rules: [] };

// Operator identifiers only — their wording lives in COMPONENTS:CONDITIONS_EDITOR.OPS.
export const OPS = [
  { value: "equals" },
  { value: "not_equals" },
  { value: "contains" },
  { value: "not_contains" },
];

const ConditionsEditor = ({
  conditions = EMPTY_CONDITIONS,
  onOperatorChange,
  onAddRule,
  onRemoveRule,
  onUpdateRule,
  emptyMessage,
  fieldPlaceholder,
}) => {
  const { t } = useTranslation(NAME_SPACES.COMPONENTS);
  const CONDITIONS_EDITOR = t("CONDITIONS_EDITOR", { returnObjects: true });
  const resolvedEmptyMessage = emptyMessage ?? CONDITIONS_EDITOR.EMPTY_MESSAGE;
  const resolvedFieldPlaceholder =
    fieldPlaceholder ?? CONDITIONS_EDITOR.FIELD_PLACEHOLDER;
  const { operator, rules } = conditions;

  return (
    <div className="conditions-editor">
      <div className="conditions-editor__header">
        <span className="conditions-editor__title">
          {CONDITIONS_EDITOR.TITLE}
        </span>
        {rules.length > 1 && (
          <Select
            size="small"
            className="conditions-editor__operator-select"
            value={operator}
            onChange={onOperatorChange}
            options={[
              { label: CONDITIONS_EDITOR.AND, value: "AND" },
              { label: CONDITIONS_EDITOR.OR, value: "OR" },
            ]}
          />
        )}
      </div>

      {rules.length === 0 && (
        <p className="conditions-editor__empty">{resolvedEmptyMessage}</p>
      )}

      <div className="conditions-editor__rules">
        {rules.map((rule, idx) => (
          <div key={idx} className="conditions-editor__rule">
            {idx > 0 && (
              <div className="conditions-editor__rule-connector">
                {operator === "AND"
                  ? CONDITIONS_EDITOR.AND
                  : CONDITIONS_EDITOR.OR}
              </div>
            )}
            <div className="conditions-editor__rule-row">
              <PayloadPathSelect
                className="conditions-editor__field-select"
                placeholder={resolvedFieldPlaceholder}
                value={rule.key}
                onChange={(val) => onUpdateRule(idx, { key: val })}
              />
              <button
                type="button"
                onClick={() => onRemoveRule(idx)}
                className="conditions-editor__remove-btn"
              >
                <BiTrash size={14} />
              </button>
            </div>
            <div className="conditions-editor__value-row">
              <Select
                size="small"
                className="conditions-editor__op-select"
                value={rule.op}
                onChange={(val) => onUpdateRule(idx, { op: val })}
                options={OPS.map(({ value }) => ({
                  value,
                  label: CONDITIONS_EDITOR.OPS[value.toUpperCase()],
                }))}
              />
              <Input
                size="small"
                placeholder={CONDITIONS_EDITOR.VALUE_PLACEHOLDER}
                className="conditions-editor__value-input"
                value={rule.value}
                onChange={(e) => onUpdateRule(idx, { value: e.target.value })}
              />
            </div>
          </div>
        ))}
      </div>

      <button
        type="button"
        onClick={onAddRule}
        className="conditions-editor__add-btn"
      >
        <BiPlus size={14} /> {CONDITIONS_EDITOR.ADD}
      </button>
    </div>
  );
};

export default ConditionsEditor;
